import {Icon} from '@wandb/weave/components/Icon';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {Banner, BannerButton} from '../Banner';
import {useWorkspaceBanners} from './useWorkspaceBanners';

export const WorkspaceBanners = () => {
  const {
    dismissWorkspaceBanner,
    shouldShowCliVersionWarning,
    shouldShowYankedSdkWarning,
  } = useWorkspaceBanners();
  return (
    <TailwindContents>
      {shouldShowYankedSdkWarning && (
        <Banner variant="warning" className="mx-16 mt-16">
          <p>
            <strong>
              This run was logged with SDK v0.24.0, which has a known bug that
              may cause run data to silently fail to upload.
            </strong>{' '}
            Please upgrade with{' '}
            <span className="p-4 font-mono text-sm">
              pip install wandb --upgrade
            </span>{' '}
            and re-log any affected runs.
          </p>
          <BannerButton
            aria-label="Dismiss banner"
            text={<Icon name="close" className="h-18 w-18" />}
            onClick={() => dismissWorkspaceBanner('yanked-sdk-warning')}
          />
        </Banner>
      )}
      {shouldShowCliVersionWarning && (
        <Banner variant="announcement" className="mx-16 mt-16">
          <p>
            This run was created with an older version of the W&B CLI. Please
            upgrade with{' '}
            <span className="p-4 font-mono text-sm">
              pip install wandb --upgrade
            </span>{' '}
            if you haven't already done so.
          </p>
          <BannerButton
            aria-label="Dismiss banner"
            text={<Icon name="close" className="h-18 w-18" />}
            onClick={() => dismissWorkspaceBanner('cli-version-warning')}
          />
        </Banner>
      )}
    </TailwindContents>
  );
};
